import VueDeviceDetector from './VueDeviceDetector/index';
import Vue from 'vue';

Vue.use(VueDeviceDetector);
